export default __webpack_public_path__ + "static/media/thanal.a22bebff.png";